import { gql } from '@apollo/client';
import DirectMessageFragment from "../../fragments/DirectMessage";

const APPROVE_CONVERSATION = gql`mutation approveConversation($conversationId: Int!) {
	directMessageContext {
		approveConversation(conversationId: $conversationId) {
			directMessageConversationId
			lastMessage {
				...DirectMessageFragment
			}
			latestMessageId
			latestReadMessageId
			latestReadMessageTime
			members {
				name
				userId
				username
				avatarUrl
				hasApproved
			}
			isApproved
			hasCurrentUserApproved
			unreadMessageCount
		}
	}
}
${DirectMessageFragment}
`;

export default APPROVE_CONVERSATION;